import React from 'react';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';
import jQuery from 'jquery';
import toastr from 'toastr';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    Modal
} from 'react-bootstrap';
import $ from 'jquery'
import * as Msal from 'msal';
import axios from 'axios';
import * as SVGICONS from '../../images/img/images';
import * as signinActions from '../../actions/signinActions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import validator from '../common/validator.js';
// var Modal = window.ReactModalBootstrap.Modal;
// var ModalHeader = window.ReactModalBootstrap.ModalHeader;
// var ModalTitle = window.ReactModalBootstrap.ModalTitle;
// var ModalClose = window.ReactModalBootstrap.ModalClose;
// var ModalBody = window.ReactModalBootstrap.ModalBody;
// var ModalFooter = window.ReactModalBootstrap.ModalFooter;
var countries = require('country-data').countries
// import classNames from 'classnames';
// const autoBind = require('auto-bind');
//login container component
class Signin extends React.Component {
    constructor(props, context) {
        super(props, context);
        console.log('props', this.props)
        this.state = {
            forgotModalOpen: false,
            spinner: false,
            userType: { value: '1', isValid: true, message: '' },
            email: { value: '', isValid: true, message: '' },
            password: { value: '', isValid: true, message: '' },
            Ip: '',
            otpModalOpen: false,
            loginData: {}
        };
        //binding current context to all functions
        this.onChange = this.onChange.bind(this);
        this.onSigninHandler = this.onSigninHandler.bind(this);
        this.Auth = this.Auth.bind(this);
        this.resetValidationStates = this.resetValidationStates.bind(this)
        this.formIsValid = this.formIsValid.bind(this);
    }




    Auth() {
        var userAgentApplication = new Msal.UserAgentApplication('ab8fa067-8dfd-4dff-b453-db0b3f023f89', null, function (errorDes, token, error, tokenType) {
            // this callback is called after loginRedirect OR acquireTokenRedirect (not used for loginPopup/aquireTokenPopup)
        });

        return new Promise((resolve, reject) => {
            userAgentApplication.loginPopup(["user.read"]).then((token) => {
                if (token) {
                    var logindata = {
                        auth_user_name: userAgentApplication.getUser().displayableId,
                        auth_user_id: userAgentApplication.getUser().userIdentifier,
                        name: userAgentApplication.getUser().name,
                        company: "MedFix"
                    }
                    this.props.actions.signinUser(logindata, this.props);
                }
                else {
                    toastr.error("Some error occured please try again");
                }
                userAgentApplication.acquireTokenSilent(["user.read"]).then((token) => {
                    resolve(token);
                }, function (error) {
                    reject(error);
                });
            }, function (error) {
                reject(error);
            });
        });
    }
    resetValidationStates() {
        var state = this.state;
        Object.keys(state).map(key => {
            if (state[key].hasOwnProperty('isValid')) {
                state[key].isValid = true;
                state[key].message = '';
            }
        });
        this.setState(state);
    }


    onChange(e) {
        var state = this.state;
        state[e.target.name].value = e.target.value;
        this.resetValidationStates();
        if (e.target.name == "email") {
            if (e.target.value.length > 0) {
                if (!validator.isEmail(state.email.value)) {
                    state.email.isValid = false;
                    state.email.message = 'Not a valid email address';
                    this.setState(state);
                } else {
                    return true
                }
            } else {
                state.email.isValid = false;
                state.email.message = 'Email address is required';
                this.setState(state);
            }

        } else
            if (e.target.name == "password") {
                if (e.target.value.length > 0) {
                    if (!validator.isValid(state.password.value)) {
                        state.password.isValid = false;
                        state.password.message = 'Not a valid password';
                        this.setState(state);
                    } else {
                        return true
                    }
                } else {
                    state.password.isValid = false;
                    state.password.message = 'Password is required';
                    this.setState(state);
                }
            } else if (e.target.name == "userType") {
                return true
            }

        this.setState(state);
    }

    //Handler for sign-in
    onSigninHandler(event) {


        event.preventDefault();
        var state = this.state;
        if (!validator.isValid(parseInt(state.userType.value))) {
            state.userType.isValid = false;
            state.userType.message = 'Please select user type';
        } else {
            state.userType.isValid = true;
            state.userType.message = '';
        }
        if (!validator.isValid(state.email.value)) {
            state.email.isValid = false;
            state.email.message = 'Email address is required';
            this.setState(state);
        } else {
            state.email.isValid = true;
            state.email.message = '';
        }
        if (!validator.isValid(state.password.value)) {
            state.password.isValid = false;
            state.password.message = 'Password is required';
            this.setState(state);
        } else {
            state.password.isValid = true;
            state.password.message = '';
        }
        if (this.state.email.value != '' && this.state.password.value != '' && this.state.userType.value != '' && (this.state.email.message == '' || this.state.email.message == undefined) && (this.state.password.message == '' || this.state.password.message == undefined) && (this.state.userType.message == '' || this.state.userType.message == undefined)) {
            // debugger
            var signin = {
                email: this.state.email.value.toLowerCase(),
                password: this.state.password.value,
                userType: parseInt(this.state.userType.value),
                Ip: this.state.Ip
            }
            this.setState({ spinner: true })
            this.props.actions.signinUser(signin, this.props);

        }
    }

    formIsValid() {

        var state = this.state;
        // this.resetValidationStates();
        if (!validator.isValid(parseInt(state.userType.value))) {
            console.log('in if usertype')
            state.userType.isValid = false; //this will trigger the has-error class
            state.userType.message = 'Please select user type'; //will be displayed in the 
            this.setState(state);
            return false;
        } else
            if (!validator.isValid(state.email.value)) {
                state.email.isValid = false; //this will trigger the has-error class
                state.email.message = 'Email address is required'; //will be displayed in the 
                this.setState(state);
                return false;
            } else if (!validator.isValid(state.password.value)) {
                state.password.isValid = false; //this will trigger the has-error class
                state.password.message = 'Password is required'; //will be displayed in the 
                this.setState(state);
                return false;
            }
        return true;
    }

    componentWillReceiveProps(nextProps) {
        console.log("sss", nextProps)
        // debugger;
        if (nextProps.signup) {

            this.setState({ spinner: false })
            this.props.hideSignupModal()
        } else {
            this.setState({ spinner: false })
        }
        if (nextProps.signin == 'failed') {
            this.setState({ spinner: false })

        }
        if (nextProps.signin && nextProps.signin.signin && nextProps.signin.signin.token && nextProps.signin.signin.token != '') {
            this.setState({
                loginData: nextProps.signin.signin
            })
            let loginData = {
				...nextProps.signin.signin,
				signinData: {
					email: this.state.email.value.toLowerCase(),
					password: this.state.password.value,
					userType: parseInt(this.state.userType.value),
					Ip: this.state.Ip
				}
			}
            this.props.otpModal(loginData)
        }

    }

    componentDidMount() {
        let self = this;
        const SystemIpAddress = new Promise((r) => {
            // debugger;
            var w = window, a = new (w.RTCPeerConnection || w.mozRTCPeerConnection || w.webkitRTCPeerConnection)({ iceServers: [] }), b = () => { }; a.createDataChannel(''); a.createOffer((c) => a.setLocalDescription(c, b, b), b); a.onicecandidate = (c) => {
                try {
                    c.candidate.candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g).forEach(r);
                } catch (e) { }
            };
        });


        SystemIpAddress.then(function (value) {
            self.setState({
                Ip: value
            })

        }).catch((e) => console.error(e));
    }

    componentWillMount() {

        if (this.props.emailToken && this.props.emailToken != '' && this.props.emailToken != undefined) {
            var obj = {
                userId: this.props.emailToken
            }
            this.props.actions.changeEmail(obj);
        }
        var state = this.state;
        state['userType'].value = localStorage.getItem('userType') ? localStorage.getItem('userType') : '1'
        this.setState(state)
        localStorage.setItem('isDisclaimerFeedback', true)
        localStorage.setItem('isDisclaimerBlog', true)
        localStorage.setItem('isDisclaimerConsultation', true)



        navigator.geolocation.getCurrentPosition(
            function (position) {
                console.log('position___________________>', position);
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;
                console.log('lat:- ', lat, ' --> Long:- ', lng);
                localStorage.setItem('lat', lat);
                localStorage.setItem('lng', lng);
                axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + "," + lng + '&key=AIzaSyBQQtO5Ia-kb95LB-pBnKeBDeN35Z2ybbk')
                    .then(function (response) {
                        if (response) {
                            console.log(response)
                            for (var i = 0; i < response.data.results.length; i++) {
                                if (response.data.results[i].types[0] == 'country') {
                                    var countryshort = response.data.results[i].address_components[0].short_name;
                                    var countrylong = response.data.results[i].address_components[0].long_name;

                                    localStorage.setItem('country_short', countryshort)
                                    localStorage.setItem('country_long', countrylong)
                                    localStorage.setItem('currency', countries[countryshort].currencies[0]);
                                    localStorage.setItem('calling_code', countries[countryshort].countryCallingCodes[0]);
                                    localStorage.removeItem('mileDistance', 0)
                                }
                            }
                        }
                        else {
                        }
                    })
            });


    }

    render() {

        var { email, password } = this.state;
        return (
            <Modal show={this.props.openModal} size="modal-sm" onHide={this.props.hideSigninModal}>
                <Modal.Header>
                    {/* <Modal.Close onClick={this.props.hideSigninModal} /> */}
                    <Modal.Title><img src={require('../../images/images/logo.svg')} alt="" /></Modal.Title>
                    {/* <img src={require('../../images/images/logo.svg')} alt="" /> */}
                </Modal.Header>
                <Modal.Body>
                    <form className="signup-form" id="loginForm" onSubmit={this.onSigninHandler} autoComplete="new-password">
                        <div className="signIn "><span className='signInWord'>Sign In </span> to your account</div>
                        <p className="signUp">
                            New to MedFix?
						<a href="#"onClick={this.props.closeSigninOpenSignup} style={{cursor:'pointer'}}>Sign Up for Free</a></p>
                        <div className="userSpecialist">
                            <div className="cc-selector">
                                <input id="patient_img_radio" type="radio" name="userType" value="1" onChange={this.onChange} checked={this.state.userType.value === '1'} />
                                <label className="drinkcard-cc userImg patient_img_radio" htmlFor="patient_img_radio"></label>
                                <input id="specialist_img_radio" type="radio" name="userType" value="2" onChange={this.onChange} checked={this.state.userType.value === '2'} />
                                <label className="drinkcard-cc specialist_img_radio" htmlFor="specialist_img_radio"></label>
                            </div>

                        </div >
                        <div className="loginInput">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroupPrepend">
                                        <SVGICONS.EmailSvg />
                                    </span>
                                </div>
                                <input autoComplete="new-password" type="text" name="email" className="form-control"
                                    placeholder="Email Address" value={email.value} onChange={this.onChange} autoFocus />
                                <span className="help-block">{email.message}</span>
                            </div>
                            {/* <ToastContainer /> */}
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroupPrepend">
                                        <SVGICONS.PasswordSvg />
                                    </span>
                                </div>
                                <input autoComplete="new-password" type="password" name="password" className="form-control"
                                    placeholder="Password" value={password.value} onChange={this.onChange} />
                                <span className="help-block">{password.message}</span>
                                {this.state.popoverShow == true ? <div className="toolTip">
                                    <div className="tool_box">
                                        <p>Password must Meet the following requirements: </p>
                                        <ul>
                                            <li>{this.state.patternOne == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>} At least one letter</li>
                                            <li>{this.state.patternTwo == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one capital letter</li>
                                            <li>{this.state.patternThree == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one number</li>
                                            <li>{this.state.patternFour == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}Be at least 8 characters	</li>
                                        </ul>
                                    </div>
                                </div> : ''}
                            </div>
                            <div className="btngrouplogIn">
                                <button className="btn btn-primary btn-signup" data-toggle="modal" type="submit" >Sign In{this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
                            </div>
                            <Link to='/' onClick={this.props.openForgotModal} className="forgetPass" >
                                Forgot Password?</Link>

                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal >
        );
    }
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
    return {
        signin: state.signin
    };
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(signinActions, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Signin);